import React, { useState, useEffect } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import FormCheckInput from 'react-bootstrap/FormCheckInput';
import Alert from 'react-bootstrap/Alert'

function SearchesTable({onLoaded}) {
    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showAddEditModal, setShowAddEditModal] = useState(false);
    const [currentSearch, setCurrentSearch] = useState(null);
    const [showAddedAlert, setShowAddedAlert] = useState(false);
    const [showUpdatedAlert, setShowUpdatedAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);

    // State for object being manipulated in Add/Edit modal
    const [currentOrganisationId, setCurrentOrganisationId] = useState('');
    const [currentSearchId, setCurrentSearchId] = useState('');
    const [currentName, setCurrentName] = useState('');
    const [currentInstruction, setCurrentInstruction] = useState('');
    const [currentIsNew, setCurrentIsNew] = useState(false);

    const fetchData = async (forceRefresh = false) => {
      if (fetching) return;
      
      setFetching(true);
      setSelectedRows([]);

      const isLocalMode = (window.global_LocalMode !== undefined && window.global_LocalMode === true);
      const cacheBuster = new Date().getTime();
      const refreshSuffix = forceRefresh ? '&refresh=true' : '';

      var searchesUrl = '/Searches';

      if (isLocalMode) {
        searchesUrl = searchesUrl + '.json';
      } else {
        searchesUrl = searchesUrl + '?k=signalTriage2025&_=' + cacheBuster + refreshSuffix;
      }

      const response = await fetch(searchesUrl);          

      if (response.ok) {
        const activeSearches = await response.json();    
        activeSearches.sort((a,b) => { 
          if (a.Name.toLowerCase() < b.Name.toLowerCase()) { return -1; } 
          else if (a.Name.toLowerCase() > b.Name.toLowerCase()) { return 1; } 
          return 0;
        });    
        setData(activeSearches);        
      }

      setFetching(false);
      onLoaded();
    };

    useEffect(() => {   
        const refresh = new URLSearchParams(window.location.search).has('refresh');

        if (refresh) {
          const url = new URL(window.location);
          const params = new URLSearchParams(url.search);
          params.delete('refresh');
          window.history.replaceState({}, '', `${url.pathname}?${params}`);
          fetchData(true);          
        } else {
          fetchData();
        }
    }, []);

    const resetNotificationState = () => {
      setShowAddedAlert(false);
      setShowUpdatedAlert(false);
      setShowDeleteAlert(false);
      setShowErrorAlert(false);
    }

    const handleCheckInput = async (el, row) => {
      if (el.target.checked) {
        setSelectedRows([...selectedRows, row]);
      } else {
        setSelectedRows(selectedRows.filter((item) => item !== row));
      }
    }

    const hasSelectedRows = () => {
      return selectedRows.length > 0;
    }

    const hasSingleSelection = () => {
      return selectedRows.length === 1;
    }

    const handleAddNewClick = async () => {   
      resetNotificationState();
      setCurrentIsNew(true);   
      setCurrentOrganisationId('');
      setCurrentSearchId('');      
      setCurrentName('');
      setCurrentInstruction('');
      setCurrentSearch({
        SearchId: '',
        OrganisationId: '',        
        Name: '',
        Instruction: ''
        });
      setShowAddEditModal(true);
    }

    const handleEditClick = async () => {  
      resetNotificationState();
      setCurrentIsNew(false);    
      setCurrentOrganisationId(selectedRows[0].OrganisationId);
      setCurrentSearchId(selectedRows[0].SearchId);      
      setCurrentName(selectedRows[0].Name);
      setCurrentInstruction(selectedRows[0].Instruction || '');
      setCurrentSearch({
        SearchId: selectedRows[0].SearchId,
        OrganisationId: selectedRows[0].OrganisationId,        
        Name: selectedRows[0].Name,
        Instruction: selectedRows[0].Instruction || ''
        });
      setShowAddEditModal(true);
    }

    const handleDeleteClick = async () => {
      resetNotificationState();
      var id = selectedRows[0].SearchId;
      try
      {
        const url = '/Search/Delete?id=' + id;
        const response = await fetch(url, { method: 'POST' });

        if (response.status === 200) {
          setShowDeleteAlert(true);
          setData(data.filter((item) => !selectedRows.includes(item)));
          setSelectedRows([]);
          
          var inputs = document.getElementsByTagName('input');
          for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].type === 'checkbox') {
              inputs[i].checked = false;
            }
          }
        } else {
          setShowErrorAlert(true);
        } 
      }
      catch (e)
      {
        setShowErrorAlert(true);
      }
    }

    const handleAddEditSave = async () => {
      currentSearch.OrganisationId = currentOrganisationId;
      currentSearch.SearchId = currentSearchId;
      currentSearch.Name = currentName;
      currentSearch.Instruction = currentInstruction;
      
      var url = '/Search/Save';      

      try
      {                
        const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json'}, body: JSON.stringify(currentSearch) });

        if (response.status === 200) {
          if (currentIsNew) {
            setData([...data, currentSearch]);
            setShowAddedAlert(true);
          } else {        
            selectedRows[0].Name = currentName;
            selectedRows[0].Instruction = currentInstruction;
            setData([...data]);
            setShowUpdatedAlert(true);
          }        
        } else {
          setShowErrorAlert(true);
        } 
      }
      catch (e)
      {
        setShowErrorAlert(true);
      }
      
      setCurrentSearch(null);  
      setShowAddEditModal(false);
    }

    const handleAddEditClose = () => {
      setCurrentSearch(null);  
      setShowAddEditModal(false);
    }

    return (
        <div className="container">     
            <div>
              {showAddedAlert && 
                <Alert variant="success">
                    Search has been added.
                </Alert>
              }
              {showUpdatedAlert && 
                <Alert variant="success">
                    Search has been updated.
                </Alert>
              }
              {showDeleteAlert && 
                <Alert variant="success">
                    Search has been deleted.
                </Alert>
              }
              {showErrorAlert && 
                <Alert variant="danger">
                    An error occurred, please try again.
                </Alert>
              }
            </div>                       
            <div>                
                <div style={{float: 'right'}}>
                <Button className={hasSelectedRows() ? 'disabled' : ''} style={{fontSize: '16px'}} variant={hasSelectedRows() ? 'light' : 'info'} onClick={() => handleAddNewClick()}>
                Add
                </Button>
                &nbsp;
                <Button className={hasSingleSelection() ? '' : 'disabled'} style={{fontSize: '16px'}} variant={hasSingleSelection() ? 'success' : 'light'} onClick={() => handleEditClick()}>
                Edit
                </Button>
                &nbsp;
                <Button className={hasSingleSelection() ? '' : 'disabled'} style={{fontSize: '16px'}} variant={hasSingleSelection() ? 'danger' : 'light'} onClick={() => handleDeleteClick()}>
                Delete
                </Button>    
                </div>                        
            </div>
            <div>
            </div>
            <div className="clearfix"></div>
            <br/>
            <ListGroup style={{maxHeight: '75vh', overflowY: 'auto'}}>
                {data.map((row, index) => (
                    <ListGroup.Item key={index}>
                        <div style={{float: 'left'}}>
                          {!row.Protected && (
                            <FormCheckInput onClick={(el) => handleCheckInput(el, row)}></FormCheckInput>
                          )}
                          {row.Protected && (
                            <FormCheckInput disabled></FormCheckInput>
                          )}
                        </div>                        
                        <div style={{float: 'left', marginLeft: '10px'}}>
                          <span>Id: <b>{row.SearchId}</b> - <span style={{color: '#666666'}}>{row.Name}</span></span>
                          {row.Instruction && (
                            <div style={{fontSize: '12px', color: '#999999', marginTop: '4px'}}>
                              Instruction: {row.Instruction}
                            </div>
                          )}
                        </div>                                                
                    </ListGroup.Item>
                ))}
            </ListGroup>
            <Modal show={showAddEditModal} onHide={handleAddEditClose} dialogClassName="knownSourceAddEditModal">
                <Modal.Header closeButton>
                {currentSearch && currentIsNew && (
                    <Modal.Title>Add a new search</Modal.Title>
                )}
                {currentSearch && !currentIsNew && (
                    <Modal.Title>Edit existing search</Modal.Title>
                )}
                </Modal.Header>
                <Modal.Body>
                  <form>
                    <table width='100%'>
                      <tbody>
                      <tr>
                          <td><label>Organisation Id:</label></td>
                          <td>
                            {currentSearch && currentIsNew && (
                            <FormControl size="sm" type="text" required value={currentOrganisationId} onChange={(e) => setCurrentOrganisationId(e.target.value)}/>
                            )}
                            {currentSearch && !currentIsNew && (
                            <p>{currentOrganisationId}</p>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td><label>Search Id:</label></td>
                          <td>
                            {currentSearch && currentIsNew && (
                            <FormControl size="sm" type="text" required value={currentSearchId} onChange={(e) => setCurrentSearchId(e.target.value)}/>
                            )}
                            {currentSearch && !currentIsNew && (
                            <p>{currentSearchId}</p>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td><label>Name:</label></td>
                          <td>
                            {currentSearch && (
                            <FormControl size="sm" type="text" required value={currentName} onChange={(e) => setCurrentName(e.target.value)}/>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td><label>Custom Instruction:</label></td>
                          <td>
                            {currentSearch && (
                            <FormControl as="textarea" rows={3} size="sm" value={currentInstruction} onChange={(e) => setCurrentInstruction(e.target.value)}/>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={handleAddEditSave}>
                        Save
                    </Button>
                    <Button variant="danger" onClick={handleAddEditClose}>
                        Cancel
                    </Button>
                </Modal.Footer>                          
            </Modal>
        </div>
    );
}

export default SearchesTable;
